module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2ODc4ZDU1ZTM2MTVjY2Y0MGMzODZlYzJhOTBkZmQ2YS5zdmciOw=="